import { Component, OnInit } from '@angular/core';
import { RestDataService } from '../../service/rest-data.service';
import { Config } from '../../config/config';
import { StaticDataService } from '../../service/static-data.service';
import { SnotifyService } from 'ng-snotify';
import { SharedDataService } from '../../service/shared-data.service';
import { Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-breaking-news-listing',
  templateUrl: './breaking-news-listing.component.html',
  styleUrls: ['./breaking-news-listing.component.scss']
})
export class BreakingNewsListingComponent implements OnInit {

  callFail = false;
  currentPageNum = 0;
  editingURL = '';
  currentSelectedIndex = -1;
  listArray = [];
  lastPage = false;
  monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  searchQuery: FormControl = new FormControl();
  constructor(
    private config: Config,
    private restService: RestDataService,
    private snotify: SnotifyService,
    private sharedService: SharedDataService,
    private router: Router
  ) { }

  ngOnInit() {
    this.searchResult(this.searchQuery.value, 0, data => {
      console.log(data);
      this.listArray = data['content'];
    });
    this.searchQuery.valueChanges
      .pipe(debounceTime(1200)
      ,distinctUntilChanged())
      .subscribe(result => {
        this.searchResult(result, 0, data => {
          console.log(data);
          this.listArray = data['content'];
        });
      });
  }

  getDefaultList(pageNum, callback) {
    const url = this.config.get('product').baseUrl + '/api/cms/breakingnews' + '?page=' + pageNum + '&size=' + 5 + '&sort=createdDate,desc';
    this.callFail = false;
    this.restService.http_get(url)
      .subscribe(data => {
        if (data && !data.hasOwnProperty('error')) {
          this.currentPageNum = pageNum;
          this.callFail = false;
        } else {
          this.callFail = true;
        }
        callback(data);
      });
  }

  searchResult(query, pageNum, callback) {
    console.log(query);
    if (query && query.trim() !== '') {
      const url = this.config.get('product').baseUrl + '/api/cms/breakingnews'
        + '?page=' + pageNum + '&size=' + 5 + '&sort=createdDate,desc&search=text~' + query;
      this.callFail = false;
      console.log('calling', url);
      this.restService.http_get(url)
        .subscribe(data => {
          if (data && !data.hasOwnProperty('error')) {
            this.currentPageNum = pageNum;
            this.callFail = false;
          } else {
            this.callFail = true;
          }
          callback(data);
        });
    } else {
      this.getDefaultList(pageNum, data => {
        this.lastPage = data['last'];
        this.listArray = data['content'];
      });
    }
  }

  callMoreData() {
    const pagenum = this.currentPageNum + 1;
    this.searchResult(this.searchQuery.value, pagenum, data => {
      console.log(data);
      this.listArray = [...this.listArray, ...data['content']];
    });
  }

  pickItem(item) {
    if (!item.url || item.url.trim() === '') {
      const story = JSON.parse(JSON.stringify(StaticDataService.defaultStoryData));
      story.type = 'story';
      story.mobileHeadline = item.headline;
      story.metadata.breakingNews = true;
      story.metadata.breakingNewsId = item.id;
      if (!!item.image) {
        const defaultImagecardData = JSON.parse(JSON.stringify(StaticDataService.defaultImageCardData));
        defaultImagecardData.domainId = sessionStorage.getItem(StaticDataService.domainLiteral);
        defaultImagecardData.id = null;
        defaultImagecardData.createdBy = JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral)).user.emailId;
        defaultImagecardData.image = item.image;
        this.restService.http_post(this.config.get('product').baseUrl
          + this.config.getEndPoint(this.config.get('views'), 'element', 'get_element'),
          defaultImagecardData, result => {
            if (!result.hasOwnProperty('error')) {
              story.leadMedia.elements = [result.id];
              this.saveStoryAndRedirect(story);
            } else {
              this.saveStoryAndRedirect(story);
            }
          });
      } else {
        this.saveStoryAndRedirect(story);
      }
    }
  }

  saveStoryAndRedirect(story) {
    this.restService.http_post(this.config.get('product').baseUrl
    + this.config.getEndPoint(this.config.get('views'), 'story_main', 'save_story'),
    story, result => {
      this.router.navigate(['/dash/story/' + result['id']]);
    });
  }

  selectEditItem(index,url) {
    this.currentSelectedIndex = index;
    this.editingURL = url;
  }

  saveEditItem(i, item) {
    const newItem = item;
    newItem.url = this.editingURL;
    const url = this.config.get('product').baseUrl + '/api/cms/breakingnews/' + item.id;
    this.restService.http_put(url, newItem, result => {
      if (result && !result.hasOwnProperty('error')) {
        this.currentSelectedIndex = -1;
        this.listArray[i] = result;
        this.editingURL = '';
      } else {
        this.snotify.clear();
        this.snotify.info('Item saving Failure', '', this.sharedService.getConfig(false));
      }
    });
  }

  getNewTypeDate(datestring) {
    if (datestring) {
      if (typeof datestring === 'string') {
        const dt = new Date(datestring.replace('+0000', 'Z'));
        return this.getFullDate(Math.round(dt.getTime()));
      } else {
        return this.getFullDate(datestring);
      }
    } else {
      return 'not present';
    }
  }

  getFullDate(seconds) {
    if (seconds) {
      const date = new Date(seconds);
      return '' + this.monthNames[date.getMonth()] + ' ' + date.getDate() + ', ' + ' ' + date.getFullYear() + ', ' +
        ((date.getHours() < 10) ? '0' + date.getHours() : date.getHours()) + ':'
        + ((date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes());
    } else {
      return 'not present';
    }
  }
}
